import { Component, OnInit } from '@angular/core';
import { BannerService } from '../../shared/services/banner.service';
import { Banner } from '../../shared/models/banner.model';
import * as _ from 'lodash';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-login-layout',
  templateUrl: './login-layout.component.html',
  styles: []
})
export class LoginLayoutComponent implements OnInit {
  brandLogo: Banner;
  appLogo: any;
  banners: Banner[] = [];
  isMobile: boolean;
  clientName : string;

  constructor(private bannerService: BannerService, private deviceService: DeviceDetectorService, private route: ActivatedRoute) {
    this.isMobile = this.deviceService.isMobile();
    this.clientName = this.route.snapshot.params['clientName'];
  }

  ngOnInit() {
    this.getBanners(this.clientName);
  }

  getBanners(client) {
    let clientName = client == undefined ? 'default' : client ;
    this.bannerService.getAllBannersAndBrandImage(clientName).subscribe(
      (response: Banner[]) => {
        if (response.length) {
          this.banners = response.filter(
            type => type.imageType === 'LOGIN_PAGE'
          );
          this.brandLogo = _.find(response, { imageType: 'BRAND_LOGO' });
          this.appLogo = _.find(response, { imageType: 'SEASONONE_APP_LOGO' });
        }
      }
    );
  }

  getBrandLogo(logo: Banner) {
    this.brandLogo = logo;
  }
}
